import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-change-password-route',
  templateUrl: './change-password-route.component.html',
  styleUrls: ['./change-password-route.component.scss']
})
export class ChangePasswordRouteComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
